import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isReturnUrlWithHeadersEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('returnUrlWithHeaders'),
)

export default isReturnUrlWithHeadersEnabledSelector
